import type { FaireProductEntity } from "../../entity_types/product";

export const p_kaypw4deyb: FaireProductEntity = {
  token: "p_kaypw4deyb",
  type: "product",
  name: "Rhinestone Barrel Charm Necklace",
  brandToken: "b_tstkerjyhp",
  brandName: "Merveille",
  imageUrl:
    "https://cdn.faire.com/fastly/62ec7a7d7eab551eec2a645c0210fe92765dfc6e5aae0fb852771ebfca5b017d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f52cfba94b3eb5eadf5949a367aae1ab5105f5439f783200e444e934551bc2a2.jpeg",
    "https://cdn.faire.com/fastly/66a2611707121ab53806b5ae3e8c8882c49468c87f01e38c06e2aa7e9c0f9dde.jpeg",
    "https://cdn.faire.com/fastly/298faa8cc0b9337a09e0c59c5ac3f0cd830f20b79c8dcdf6f52d755dd8ac89ff.jpeg",
    "https://cdn.faire.com/fastly/9f125cfad9cc8eb74281cb2b2596067ebf07b8fd530508c1fdc7a522fe60543b.jpeg",
  ],
  priceDollars: 11.43,
  description:
    'Featuring colorful rhinestone barrel charms on a delicate gold-tone chain, this piece delivers a playful yet polished look.\nPerfect for layering or wearing alone, making it an easy addition to everyday and giftable jewelry assortments.\n\nNecklace Length : 16" with 2" Extender\n\nFeatures\n• Rhinestone barrel charm design\n• Delicate gold-tone chain\n• Lightweight and easy to layer\n• Minimal yet eye-catching style\n• Perfect for boutique and everyday wear\n\nrhinestone charm necklace, barrel charm necklace, delicate gold necklace, colorful stone necklace, boutique fashion jewelry, layering necklace, minimalist statement necklace, women\'s fashion jewelry, trendy boutique accessory, everyday necklace,',
  tags: [],
  msrpDollars: 22.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:59.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
